import { render, staticRenderFns } from "./TagTutorial.vue?vue&type=template&id=b4b9112a&"
import script from "./TagTutorial.vue?vue&type=script&lang=js&"
export * from "./TagTutorial.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports